//  ----------------------------------------------------------------------------
//  Assignment Config
//  ----------------------------------------------------------------------------
import { resource_types } from "store/extraResource/constants";
import COLOR from "utils/constants/color";
// import { v4 as uuid } from "uuid";
import * as Sentry from "@sentry/react";
import {
    HappyPopSound,
    NextLevelSound,
    PunchSound,
    SinisterLaugh,
    VideoGameDeath,
    WowAnimation,
    cars1,
    cars2,
    cars3,
    gameSplash,
    monster1,
    monster2,
    monster3,
    monster4,
    monster5,
    multiPopSound,
    wman1,
    wman2,
    wman3,
    wman4,
    wman5,
    wman6
  } from "../assets/images";
import PlayerRonaldoPng from "../assets/images/PlayerRonaldo.png";
import SoccerBalWithFirePng from "../assets/images/Soccer_bal_with_fire.png";
import PlayerMessiPng from "../assets/images/PlayerMessi.png";
import SoccreHurtPng from "../assets/images/soccreHurt.png";
import PlayerMessiRunningPng from "../assets/images/player_messi_running.png";
import SoccerKickingBallPng from "../assets/images/soccer_kicking_ball.png";
import FingerGloveGamePng from "../assets/images/finger_glove_game.png";
import PlayerCelebratingPng from "../assets/images/player_celebrating.png";
import MulticolorSoccerBallPng from "../assets/images/multicolor_soccer_ball.png";
import PlayerRunningWithBallPng from "../assets/images/player_running_with_ball.png";
import BobbleHeadFigure2Png from "../assets/images/bobble_head_figure_2.png";
import BobbleHeadFigurePng from "../assets/images/Bobble_head_figure.png";
import PlayerKickcingBallBackwardsPng from "../assets/images/player_kickcing_ball_backwards.png";
import PlayerStandingWithBallPng from "../assets/images/player_standing_with_ball.png";
import PlayerWalkingAwayPng from "../assets/images/player_walking_away.png";
import PlayerWithBallPng from "../assets/images/player_with_ball.png";
import SassyPlayerWalkingAwayPng from "../assets/images/sassy_player_walking_away.png";
import GolieStoppingBallPng from "../assets/images/golie_stopping_ball.png";
import FootballWithFirePng from "../assets/images/football_with_fire.png";
import GirlWithFootballPng from "../assets/images/girl_with_football.png";
import PlayerJumpWithBallPng from "../assets/images/player_jump_with_ball.png";
import PlayerShoesPng from "../assets/images/player_shoes.png";
import PlayerRunWithFootballPng from "../assets/images/player_run_with_football.png";
import PlayerGoalFootballPng from "../assets/images/player_goal_football.png";
import RunThunderPng from "../assets/images/run_thunder.png";
const getFireStoreUrl = (path) => (`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/${path}?alt=media&token=6a9a7f5a-4959-431c-a305-8eabe60a4d46`)

const get1waysResourceUrl = (image) => getFireStoreUrl(`1waysresources%2F${image}`)
export const BACK_TO_BOOK={
    33:'Balcón cultural',
    41:'1nformate lessons',
    43:'Comunidad',
    49:'Conectándome',
    79:'Worksheet',
    70:"AP",
    69:"AP",
    71:"AP",
    72:"AP",
    73:"AP",
    75:"AP",
    78:"AP"
 }
 export const BOOK_REFRENCES = {
  33:'Balcón cultural',
  41:'1nformate lessons',
  43:'Comunidad',
  49:'Conectándome',
  79:'Worksheet',
  70:"AP",
  69:"AP",
  71:"AP",
  72:"AP",
  73:"AP",
  75:"AP",
  78:"AP",
  255:"1Way Story"
 }
export const PRINT_KEY={
    33:'balcónCultural',
    41:'1nformate',
    43:'comunidad',
    49:'conectandome',
    79:'Worksheet',
    70:"ap",
    69:"ap",
    71:"ap",
    72:"ap",
    73:"ap",
    75:"ap",
    78:"ap",
    255:"story"
 }

 export const US_STATE =[
    {
      "name": "Alabama",
      "code": "AL"
    },
    {
      "name": "Alaska",
      "code": "AK"
    },
    {
      "name": "Arizona",
      "code": "AZ"
    },
    {
      "name": "Arkansas",
      "code": "AR"
    },
    {
      "name": "California",
      "code": "CA"
    },
    {
      "name": "Colorado",
      "code": "CO"
    },
    {
      "name": "Connecticut",
      "code": "CT"
    },
    {
      "name": "Delaware",
      "code": "DE"
    },
    {
      "name": "Florida",
      "code": "FL"
    },
    {
      "name": "Georgia",
      "code": "GA"
    },
    {
      "name": "Hawaii",
      "code": "HI"
    },
    {
      "name": "Idaho",
      "code": "ID"
    },
    {
      "name": "Illinois",
      "code": "IL"
    },
    {
      "name": "Indiana",
      "code": "IN"
    },
    {
      "name": "Iowa",
      "code": "IA"
    },
    {
      "name": "Kansas",
      "code": "KS"
    },
    {
      "name": "Kentucky",
      "code": "KY"
    },
    {
      "name": "Louisiana",
      "code": "LA"
    },
    {
      "name": "Maine",
      "code": "ME"
    },
    {
      "name": "Maryland",
      "code": "MD"
    },
    {
      "name": "Massachusetts",
      "code": "MA"
    },
    {
      "name": "Michigan",
      "code": "MI"
    },
    {
      "name": "Minnesota",
      "code": "MN"
    },
    {
      "name": "Mississippi",
      "code": "MS"
    },
    {
      "name": "Missouri",
      "code": "MO"
    },
    {
      "name": "Montana",
      "code": "MT"
    },
    {
      "name": "Nebraska",
      "code": "NE"
    },
    {
      "name": "Nevada",
      "code": "NV"
    },
    {
      "name": "New Hampshire",
      "code": "NH"
    },
    {
      "name": "New Jersey",
      "code": "NJ"
    },
    {
      "name": "New Mexico",
      "code": "NM"
    },
    {
      "name": "New York",
      "code": "NY"
    },
    {
      "name": "North Carolina",
      "code": "NC"
    },
    {
      "name": "North Dakota",
      "code": "ND"
    },
    {
      "name": "Ohio",
      "code": "OH"
    },
    {
      "name": "Oklahoma",
      "code": "OK"
    },
    {
      "name": "Oregon",
      "code": "OR"
    },
    {
      "name": "Pennsylvania",
      "code": "PA"
    },
    {
      "name": "Rhode Island",
      "code": "RI"
    },
    {
      "name": "South Carolina",
      "code": "SC"
    },
    {
      "name": "South Dakota",
      "code": "SD"
    },
    {
      "name": "Tennessee",
      "code": "TN"
    },
    {
      "name": "Texas",
      "code": "TX"
    },
    {
      "name": "Utah",
      "code": "UT"
    },
    {
      "name": "Vermont",
      "code": "VT"
    },
    {
      "name": "Virginia",
      "code": "VA"
    },
    {
      "name": "Washington",
      "code": "WA"
    },
    {
      "name": "West Virginia",
      "code": "WV"
    },
    {
      "name": "Wisconsin",
      "code": "WI"
    },
    {
      "name": "Wyoming",
      "code": "WY"
    }
  ]




export const Categorias = [
    'Entretenimiento',
    'Tecnología',
    'Deportes',
    'Historias',
    'Cultura',
    'Música',
    'Curiosidades',
    'Cine',
    'Fantasía',
    'Realismo',
    'Ciencia ficción',
    'Magia',
    'Espacio',
    '6-8th ',
    '9-10th',
    '11-12th'
]

export const getFireBaseUrl = (imageName) => (`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/${imageName}?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222`);


export const CATEGORIAS = [
    {
        title:"All"
    },
    {
        icon: getFireBaseUrl("Entretenimiento.svg"),
        title:"Entretenimiento",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Tecnologia.svg"),
        title:"Tecnología",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Deportes.svg"),
        title:"Deportes",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Historias.svg"),
        title:"Historias",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Cultura.svg"),
        title:"Cultura",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Musica.svg"),
        title:"Música",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Curiosidades.svg"),
        title:"Curiosidades",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Cine.svg"),
        title:"Cine",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Fantasia.svg"),
        title:"Fantasía",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Realismo.svg"),
        title:"Realismo",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Ciencia_Ficcion.svg"),
        title:"Ciencia Ficción",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Magia.svg"),
        title:"Magia",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("Espacio.svg"),
        title:"Espacio",
        hiddenFrom: []
    },
    {
        icon: getFireBaseUrl("six_eight.svg"),
        title:"6-8th",
        hiddenFrom: ["story"]
    },
    {
        icon: getFireBaseUrl("six_eight.svg"),
        title:"9-10th",
        hiddenFrom: ["story"]
    },
    {
        icon: getFireBaseUrl("six_eight.svg"),
        title:"11-12th",
        hiddenFrom: ["story"]
    },
]

export const IBTHEME = [
    {
        icon: getFireBaseUrl("rocket.svg"),
        title: "Identidad"
    },
    {
        icon: getFireBaseUrl("gallery.svg"),
        title: "Experiencias"
    },
    {
        icon: getFireBaseUrl("bulb.svg"),
        title: "Ingenio humano"
    },
    {
        icon: getFireBaseUrl("people.svg"),
        title: "Organización social"
    },
    {
        icon: getFireBaseUrl("global.svg"),
        title: "Compartir el planeta"
    },
]

export const APTHEME = [
    {
        type: "AP Spanish Language",
        icon: getFireBaseUrl("globe.svg"),
        title: "Desafíos globales",
        title2: "Las sociedades en contacto",
        title2Icon: getFireBaseUrl("contact.svg")
    },
    {
        type: "AP Spanish Language",
        icon: getFireBaseUrl("lab.svg"),
        title: "Ciencia y tecnología",
        title2: "La construcción del género",
        title2Icon: getFireBaseUrl("gender.svg")
    },
    {
        type: "AP Spanish Language",
        icon: getFireBaseUrl("wait.svg"),
        title: "Vida contemporánea",
        title2: "El tiempo y el espacio",
        title2Icon: getFireBaseUrl("clock.svg")
    },
    {
        type: "AP Spanish Language",
        icon: getFireBaseUrl("shake_hand.svg"),
        title: "Identidades personales y públicas",
        title2: "La creación literaria",
        title2Icon: getFireBaseUrl("read.svg")
    },
    {
        type: "AP Spanish Language",
        icon: getFireBaseUrl("group_of_people.svg"),
        title: "Familias y comunidades",
        title2: "Las relaciones interpersonales",
        title2Icon: getFireBaseUrl("people.svg")
    },
    {
        type: "AP Spanish Language",
        icon: getFireBaseUrl("boom.svg"),
        title: "Belleza y estética",
        title2: "La dualidad del ser",
        title2Icon: getFireBaseUrl("video-duality.svg")
    },
]

export const AnecdotasThemes = {
    first_phase: [
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("union-video.svg"),
            title: "La unión como base",
            title2: "Los tipos de relaciones en la sociedad",
            title3: "La familia, el núcleo de la sociedad",
            title2Icon: getFireBaseUrl("realtionship-video.svg"),
            title3Icon: getFireBaseUrl("family-necules-video.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("youth.svg"),
            title: "La juventud, mi juventud",
            title2: "En busca de la paz",
            title3: "Mi mundo que sigue innovando",
            title2Icon: getFireBaseUrl("search-of-peace.svg"),
            title3Icon: getFireBaseUrl("my-world-video.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("my-value-video.svg"),
            title: "Los valores y mis responsabilidades",
            title2: "La inmigración en el mundo",
            title3:"Mi vida contemporánea",
            title2Icon: getFireBaseUrl("Immigration.svg"),
            title3Icon: getFireBaseUrl("contemporary.svg"),
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("redis.svg"),
            title: "Las redes nos enredan",
            title2: "La influencia de los influencers",
            title3: "Mi identidad en el mundo",
            title2Icon: getFireBaseUrl("infulencer-video.svg"),
            title3Icon: getFireBaseUrl("finger-print.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("fantasy.svg"),
            title: "La fantasía y la imaginación",
            title2: "La forma de vivir: ¿De vuelta a la normalidad o nueva normalidad?",
            title3: "Mi comunidad es también mi familia",
            title2Icon: getFireBaseUrl("living-video.svg"),
            title3Icon: getFireBaseUrl("office.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("gym-video.svg"),
            title: "Mi salud, mi vida",
            title2: "Una historia para contar: Somos latinos, somos hispanos",
            title3: "Enfrentando los desafíos del mundo",
            title2Icon: getFireBaseUrl("capa-2.svg"),
            title3Icon: getFireBaseUrl("flag.svg")
        },
    ],
    second_phase: [
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("families-link-video.svg"),
            title: "Las familias y su enlace con la sociedad",
            title2: "Las sociedades en contacto",
            title3: "Las familias en diferentes sociedades",
            title2Icon: getFireBaseUrl("Societies-link.svg"),
            title3Icon: getFireBaseUrl("family-necules-video.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("impact_culture.svg"),
            title: "El impacto de la cultura y el lenguaje en las identidades",
            title2: "La construcción del género",
            title3: "La influencia de la lengua y la cultura en la identidad",
            title2Icon: getFireBaseUrl("setting-video.svg"),
            title3Icon: getFireBaseUrl("lang-cult-video.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("paint-video.svg"),
            title: "Contemplando el arte como influencia en la vida",
            title2: "La línea del tiempo",
            title3:"La influencia de la belleza y el arte",
            title2Icon: getFireBaseUrl("timeline-video.svg"),
            title3Icon: getFireBaseUrl("influence-beauty-art.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("robot.svg"),
            title: "La tecnología y sus beneficios en la vida diaria",
            title2: "El arte, un puente hacia la literatura",
            title3: "Cómo la ciencia y la tecnología afectan nuestras vidas",
            title2Icon: getFireBaseUrl("art-bridget.svg"),
            title3Icon: getFireBaseUrl("wait-clock.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("calender.svg"),
            title: "La vida contemporánea y sus cambios en las comunidades",
            title2: "Interconexión, colaboración y resultados",
            title3: "Los factores que impactan la calidad de nuestra vida",
            title2Icon: getFireBaseUrl("link-video.svg"),
            title3Icon: getFireBaseUrl("heart-gym.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("flag.svg"),
            title: "Las sociedades frente a los retos",
            title2: "Las multiples facetas del ser humano",
            title3: "Los cambios ambientales, políticos y sociales",
            title2Icon: getFireBaseUrl("headphone-video.svg"),
            title3Icon: getFireBaseUrl("refresh-video.svg")
        },
    ],
    third_phase: [
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("flag.svg"),
            title: "People, places, and Common Professions",
            title2: "Animals and Nature",
            title3: "Tourism and Travel",
            title2Icon: getFireBaseUrl("travel-video.svg"),
            title3Icon: getFireBaseUrl("business-video.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("flag.svg"),
            title: "Family And Friends",
            title2: "School and classroom activities",
            title3: "Experiences and interactions",
            title2Icon: getFireBaseUrl("travel-video.svg"),
            title3Icon: getFireBaseUrl("business-video.svg")
        },
        {
            type: "AP Spanish Language",
            icon: getFireBaseUrl("flag.svg"),
            title: "Appearances, personality, clothes and colors",
            title2: "Traveling",
            title3: "Leisure activities",
            title2Icon: getFireBaseUrl("travel-video.svg"),
            title3Icon: getFireBaseUrl("business-video.svg")
        },
        {
          type: "AP Spanish Language",
          icon: getFireBaseUrl("flag.svg"),
          title: "Health and personal care",
          title2: "Foods and drinks",
          title3: "Media and entertainment",
          title2Icon: getFireBaseUrl("travel-video.svg"),
          title3Icon: getFireBaseUrl("business-video.svg")
        },
        {
          type: "AP Spanish Language",
          icon: getFireBaseUrl("flag.svg"),
          title: "Food, daily schedule and activities",
          title2: "Lifestyle and childhood activities",
          title3: "Vitality and wellness",
          title2Icon: getFireBaseUrl("travel-video.svg"),
          title3Icon: getFireBaseUrl("business-video.svg")
        },
        {
          type: "AP Spanish Language",
          icon: getFireBaseUrl("flag.svg"),
          title: "After-school plans and activities",
          title2: "Celebrations and Festivals",
          title3: "Shopping and fashion",
          title2Icon: getFireBaseUrl("travel-video.svg"),
          title3Icon: getFireBaseUrl("business-video.svg")
        },
        {
          type: "AP Spanish Language",
          icon: getFireBaseUrl("flag.svg"),
          title: "Around Town",
          title2: "Technology and social media",
          title3: "Kitchen and culinary arts",
          title2Icon: getFireBaseUrl("travel-video.svg"),
          title3Icon: getFireBaseUrl("business-video.svg")
        },
        {
          type: "AP Spanish Language",
          icon: getFireBaseUrl("flag.svg"),
          title: "Hobbies and interests",
          title2: "City and country life",
          title3: "Natural entertainment and ecology",
          title2Icon: getFireBaseUrl("travel-video.svg"),
          title3Icon: getFireBaseUrl("business-video.svg")
        },
    ]
}



export const HIGH_ASSESSMENTS = [
    {
        key: 'entry_exam',
        src: getFireStoreUrl("assessment%2F5_HIGHSCHOOL.jpg"),
        displayName: 'Entry Exam',
        label: "High School Level",
        bookId: 31
    },
    {
        key: 'midterm_exam',
        src: getFireStoreUrl("assessment%2F7_HIGHSCHOOL.jpg"),
        displayName: 'Midterm Exam',
        label: "High School Level",
        bookId: 51
    },
    {
        key: 'final_exam',
        src: getFireStoreUrl("assessment%2F9_HIGHSCHOOL.jpg"),
        displayName: 'Final Exam',
        label: "High School Level",
        bookId: 36
    },
]

export const MIDDLE_ASSESSMENTS = [
    {
        key: 'middle_entry_exam',
        src: getFireStoreUrl("assessment%2F5.jpg"),
        displayName: 'Entry Exam',
        label: "Middle School Level",
        bookId: 45
    },
    {
        key: 'middle_midterm_exam',
        src: getFireStoreUrl("assessment%2F7.jpg"),
        displayName: 'Midterm Exam',
        label: "Middle School Level",
        bookId: 50
    },
    {
        key: 'middle_final_exam',
        src: getFireStoreUrl("assessment%2F9.jpg"),
        displayName: 'Final Exam',
        label: "Middle School Level",
        bookId: null
    },
]



export const ResourceSymbol = {
    herramientas: {
        bg: get1waysResourceUrl("gloab.png"),
        img1: get1waysResourceUrl("brain.png")
    },
    ruzia: {
        bg: get1waysResourceUrl("gloab.png"),
        img1: get1waysResourceUrl("pinkgirl.png"),
        img2: get1waysResourceUrl("yplay.png")

    },
    avina: {
        bg: get1waysResourceUrl("gloab.png"),
        img1: get1waysResourceUrl("orangeboy.png")
    },
    americaPodcast: {
        bg: get1waysResourceUrl("gloabrec.png")
    },
    matias: {
        bg: get1waysResourceUrl("gloab.png"),
        img1: get1waysResourceUrl("manwithball.png")
    }

}


export const COTATION = [
    {
        message: "Lo que importa en la vida no es lo que te ocurre, sino lo que recuerdas y cómo lo recuerdas",
        author: "Gabriel García Márquez"
    },
    {
        message: "El amor es eterno mientras dura",
        author: "Gabriel García Márquez"
    },
    {
        message: "Puedes ser solamente una persona para el mundo, pero para una persona tú eres el mundo",
        author: "Gabriel García Márquez"
    },
    {
        message: "Nunca dejes de sonreír, ni siquiera cuando estés triste, porque nunca sabes quién se puede enamorar de tu sonrisa",
        author: "Gabriel García Márquez"
    },
    {
        message: "También el amor se aprende",
        author: "Gabriel García Márquez"
    },
    {
        message: "Leer un poema es escucharlo con los ojos; oírlo es verlo con nuestros oídos",
        author: "Octavio Paz"
    },
    {
        message: "Un verdadero amigo es quien te toma de la mano y te toca el corazón",
        author: "Gabriel García Márquez"
    },
    {
        message: "Me gustaría ser valiente mi dentista asegura que no lo soy",
        author: "Jorge Luis Borges",
        size:"sml"
    },
    {
        message: "Soñar es la actividad estética más antigua",
        author: "Jorge Luis Borges",
        size:"sml"
    },
    {
        message: "He sospechado alguna vez que la única cosa sin misterio es la felicidad, porque se justifica por sí sola",
        author: "Jorge Luis Borges"
    },
    {
        message: "El tiempo es el mejor antologista, o el único, tal vez",
        author: "Jorge Luis Borges",
        size:"sml"
    },
    {
        message: "Si viéramos realmente el universo, tal vez lo entenderíamos",
        author: "Jorge Luis Borges",
        size:"sml"
    },
    {
        message: "El cine es mi vida mi biografía",
        author: "Guillermo del Toro",
        size:"sml"
    },
    {
        message: "Elige un trabajo que ames, y no tendrás que trabajar un solo día de tu vida",
        author: "Confucio"
    },
    {
        message: "Un día sin risa es un día perdido",
        author: "Charles Chaplin",
        size:"sml"
    },
    {
        message: "No tengo talentos especiales solo soy apasionadamente curioso",
        author: "Albert Einstein",
        size:"sml"
    },
    {
        message: "No cuentes los días, haz que los días cuenten",
        author: "Muhammad Ali",
        size:"sml"
    },
    {
        message: "No hay camino para la verdad, la verdad es el camino",
        author: "Mahatma Gandhi",
        size:"sml"
    },
    {
        message: "Escribe lo que no debe ser olvidado",
        author: "Isabel Allende",
        size:"sml"
    },
    {
        message: "Merece tu sueño",
        author: "Octavio Paz",
        size:"sml"
    },
    {
        message: "Si se quiere viajar lejos, no hay mejor nave que un libro",
        author: "Emily Dickinson",
        size:"sml"
    },
    {
        message: "La mejor vida no es la más duradera, sino aquella que está repleta de buenas acciones",
        author: "Marie Curie"
    },
    {
        message: "No hay nada más hermoso que la risa",
        author: "Frida Kahlo",
        size:"sml"
    },
    {
        message: "Las tristezas no se quedan para siempre cuando caminamos en dirección a lo que siempre hemos deseado",
        author: "Paulo Coelho"
    },
    {
        message: "De la quietud nace la inspiración y del movimiento surge la creatividad",
        author: "Isabel Allende"
    },
    {
        message: "Me pinto a mí misma porque soy a quien mejor conozco",
        author: "Frida Kahlo",
        size:"sml"
    },
    {
        message: "Cuando quieres realmente una cosa, todo el universo conspira para ayudarte a conseguirla",
        author: "Paulo Coelho"
    },
    {
        message: "El que busca la verdad corre el riesgo de encontrarla",
        author: "Isabel Allende",
        size:"sml"
    },
    {
        message: "Si vas a ser alguien, debes ser un líder, no un seguidor sé fuerte, lo imposible siempre es posible",
        author: "Selena Quintanilla-Pérez, cantante y compositora",
        size:"sml"
    },
    {
        message: "Donde no puedas amar, no te demores",
        author: "Frida Kahlo",
        size:"sml"
    },
    {
        message: "Recordar un buen momento es sentirse feliz de nuevo",
        author: "Gabriela Mistral",
        size:"sml"
    },
    {
        message: "La libertad es contagiosa, uno siempre quiere más",
        author: "Yoani Sánchez",
        size:"sml"
    },
    {
        message: "No digas lo que piensas, pero piensa lo que dices",
        author: "Gabriela Mistral",
        size:"sml"
    },
    {
        message: "No le tengo miedo a nada, no me quejo incluso cuando me ocurren cosas horribles, continúo hacia adelante",
        author: "Sofía Vergara"
    },
    {
        message: "El éxito está en la vida que uno lleva, en cómo vive, cómo goza, cómo se integra, cómo disfruta de las pequeñas cosas",
        author: "Laura Esquivel"
    },
    {
        message: "Damos la vida sólo a lo que odiamos",
        author: "Rosario Castellanos",
        size:"sml"
    },
    {
        message: "El mayor peligro que nos depara el futuro es la apatía",
        author: "Jane Goodall",
        size:"sml"
    },
    {
        message: "Debemos decirles a nuestras jóvenes que sus voces son importantes",
        author: "Malala Yousafzai"
    },
    {
        message: "Nada es imposible, la propia palabra lo dice: puedo hacerlo",
        author: "Audrey Hepburn",
        size:"sml"
    },
    {
        message: "La paz comienza con una sonrisa",
        author: "Madre Teresa de Calcuta",
        size:"sml"
    }
];

export const BookSynoname =
{
    "1": "AM3",
    "2": "C2",
    "3": "C3",
    "4": "C4",
    "5": "C%",
    "6": "C6",
    "7": "A1",
    "8": "A2",
    "9": "AL1",
    "10": "AL2",
    "11": "A1W",
    "12": "A2W",
    "13": "A1A",
    "14": "A2A",
    "15": "",
    "16": "",
    "17": "",
    "18": "",
    "19": "",
    "20": "",
    "21": "",
    "22": "",
    "23": "A1-D",
    "24": "A2-D",
    "25": "AL1-D",
    "26": "AL2-D",
    "27": "A1A-D",
    "28": "A2A-D",
    "29": "A1W-D",
    "30": "A2W-D",
    "31": "H-E1",
    "32": "AI",
    "33": "BAC",
    "34": "AI-D",
    "35": "ME",
    "36": "Examen final",
    "37": "AIW",
    "45": "M-E1",
    "49": "CO",
    "50":"M-E2",
    "51":"H-E2"
}

export const INFORMATE_BASE64 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/ebook%2FInformate%2FPortadas%2FCoverPrincipal.jpg?alt=media&token=51d94eac-9f4d-4800-9f71-3a245b784018'

export const COMUNIDAD_BASE64 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/portadas%2FComunidad%2FCOVER.jpg?alt=media&token=b1117529-629c-4274-86c6-b4c8b54cb220'

export const BALCON_COVER_BASE64 = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/ebook%2FBCultural%2F1%20Portada.jpg?alt=media&token=035a095d-91f6-4c20-b760-e64e80afb13b'

export const CONECTANDOME_IMG = 'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/ebook%2FConectandome%2FConectandome%20%20Portada.jpg?alt=media&token=0d812807-2f03-439f-a2bd-fe118e55bb1c'

export const KEY_FOR_REMOVE = ["cureentClassId", "coatationLoader", "cureentClassId", "islodadedOnceBalcon", "cureentClassId", "newsLatterCurrentClass", "notes_visited", "question_visited", "currentUserId", "videoScreenloaded", "adminVisualClassId", "currentClassIdForGrade", "gradebookUserId", "schoologyhandled", "currentClassId","forUser",'admin_last_update','isApLoaded','is_comuni','is_conectan_load','is_story_load']

export const ASSIGNMET_GRADE_DISPLAY = [
  {
    name: "Percentage",
    grade: "percent",
  },
  {
    name: "Complete/Incomplete",
    grade: "complete_incomplete",
  },
];


export const GRADE_TYPE_ALL = [
    {
        type: 'Percentage',
        value: 'percent',
    },
    {
        type: 'Points',
        value: 'points',
    }
]
   export const GRADE_TYPE_CANVAS = [
    {
        type:'Percentage',
        value:'percent',
    },
    {
        type:'Points',
        value:'points',
    },
    {
        type:'Complete / Incomplete ',
        value:'complete_incomplete',
    }]


export const SPANISH_ITEM_LOWER = ["á", "é", "í", "ó", "ú", "ü", "ñ", "¿", "?", "¡", "!"];
export const SPANISH_ITEM_UPPER = ["Á", "É", "Í", "Ó", "Ú", "Ü", "Ñ", "¿", "?", "¡", "!"];

export const QUESTION_TYPE_ACTIVITY_NON_NATIVE = [
    {
        type: 'Written Response',
        value: 'essay',
    },
    {
        type: 'Audio-Recording (also upload your own)',
        value: 'audio',
    },
    {
        type: 'Multiple Choice',
        value: 'multipleChoice',
    },
    {
        type: 'Multiple-Response (Multiple-Choice)',
        value: 'multipleResponse',
    },
    {
        type: 'True And False',
        value: 'trueFalse',
    },
    {
        type: 'Image',
        value: 'picture',
    },
    {
        type: 'Video-Recording (also upload your own)',
        value: 'video',
    },
    {
        type: 'Fill in the Blanks',
        value: 'filling',
    },
    // {
    //     type: 'Filling The Blanks With Image',
    //     value: 'fillingImage',
    // },
    {
        type: 'Match Making',
        value: 'match',
    },
    {
        type: 'Audio-Recording (also upload your own) with Written Response',
        value: 'audioEssay',
    },
    {
        type: 'Audio-Recording (also upload your own) with True And False',
        value: 'audioTrueFalse',
    },
    {
        type: 'Audio-Recording (also upload your own) with Image Response',
        value: 'audioToImage',
    },
    {
      type: 'Audio with Multiple Choice',
      value: 'audioMultipleChoice',
    },
    {
        type: 'Photo Collage',
        value: 'photoCollage',
      }
]

export const DURATIONS = [
  {
    duration: 20,
    label: '20s',
    value: 20
},
  {
    duration: 30,
    label: '30s',
    value: 30
},
{
    duration: 60,
    label: '1m',
    value: 60
},
{
    duration: 90,
    label: '1m 30s',
    value: 90
},
{
    duration: 120,
    label: '2m',
    value: 120
},
{
    duration: 150,
    label: '2m 30s',
    value: 150
},
{
    duration: 180,
    label: '3m',
    value: 180
},
{
    duration: 210,
    label: '3m 30s',
    value: 210
},
{
    duration: 240,
    label: '4m',
    value: 240
},
{
    duration: 270,
    label: '4m 30s',
    value: 270
},
{
    duration: 300,
    label: '5m',
    value: 300
}
]

export const VIDEO_DURATIONS = [
  {
    duration: 20,
    label: '20s',
    value: 20
},
  {
    duration: 30,
    label: '30s',
    value: 30
},
{
    duration: 60,
    label: '1m',
    value: 60
},
{
    duration: 90,
    label: '1m 30s',
    value: 90
}
]

export const RECORDER_TYPE = [
    {
        id: "1",
        value: "recorder",
        label: "Record"
        
    },
    {   id: "2",
        value: "uploader",
        label: "Upload"
    }
]

export const IB_Theme = [
    'Identidad',
    'Experiencias',
    'Ingenio humano',
    'Organización social',
    'Compartir el planeta',   
]

export const AP_THEME = [
    "Desafíos globales",
    "Ciencia y tecnología",
    "Vida contemporánea",
    "Identidades personales y públicas",
    "Familias y comunidades",
    "Belleza y estética",
    "Las sociedades en contacto",
    "La construcción del género",
    "El tiempo y el espacio",
    "La creación literaria",
    "Las relaciones interpersonales",
    "La dualidad del ser"
];

export const ANÉCDOTAS_THEMES = [
    'La unión como base',
    'Los tipos de relaciones en la sociedad',
    'La familia, el núcleo de la sociedad',
    'La juventud, mi juventud',
    'En busca de la paz',
    'Mi mundo que sigue innovando',
    'Los valores y mis responsabilidades',
    'La inmigración en el mundo',
    'Mi vida contemporánea',
    'Las redes nos enredan',
    'La influencia de los influencers',
    'Mi identidad en el mundo',
    'La fantasía y la imaginación',
    'La forma de vivir: ¿De vuelta a la normalidad o nueva normalidad?',
    'Mi comunidad es también mi familia',
    'Mi salud, mi vida',
    'Una historia para contar: Somos latinos, somos hispanos',
    'Enfrentando los desafíos del mundo',
    'Las familias y su enlace con la sociedad',
    'Las sociedades en contacto',
    'Las familias en diferentes sociedades',
    'El impacto de la cultura y el lenguaje en las identidades',
    'La construcción del género',
    'La influencia de la lengua y la cultura en la identidad',
    'Contemplando el arte como influencia en la vida',
    'La línea del tiempo',
    'La influencia de la belleza y el arte',
    'La tecnología y sus beneficios en la vida diaria',
    'El arte, un puente hacia la literatura',
    'Cómo la ciencia y la tecnología afectan nuestras vidas',
    'La vida contemporánea y sus cambios en las comunidades',
    'Interconexión, colaboración y resultados',
    'Los factores que impactan la calidad de nuestra vida',
    'Las sociedades frente a los retos',
    'Las múltiples facetas del ser humano',
    'Los cambios ambientales, políticos y sociales',
    // Added themes
    'People, places, and Common Professions',
    'Animals and Nature',
    'Tourism and Travel',
    'Family And Friends',
    'School and classroom activities',
    'Experiences and interactions',
    'Appearances, personality, clothes and colors',
    'Traveling',
    'Leisure activities',
    'Health and personal care',
    'Foods and drinks',
    'Media and entertainment',
    'Food, daily schedule and activities',
    'Lifestyle and childhood activities',
    'Vitality and wellness',
    'After-school plans and activities',
    'Celebrations and Festivals',
    'Shopping and fashion',
    'Around Town',
    'Technology and social media',
    'Kitchen and culinary arts',
    'Hobbies and interests',
    'City and country life',
    'Natural entertainment and ecology'
];


export const initialPermissions = {
    "1nformate": true,
    "comunidad": true,
    "balcónCultural": true,
    "1WAYRESOURCES": true,
    "exams": true,
    "1WAYTEACHER": true,
    "conectandome": true,
    "printing": true,
    "lessonPlan": true,
    "teacherEdition": true,
    "active": true,
    "userActive": true,
    "books": [],
    "ap": true,
    "1WAYSTORY": true,
    "print_permission": {   "1nformate":false,     "comunidad":false,     "balcónCultural":false,     "conectandome":false,     "ap":false,     "story":false , "exam":"false" , "11":false , "12":false , "37":false , "140":false , "143":false , "153":false , "195":false , "268":false }
}

export const COLORS = [
    COLOR.PinkExam,
    COLOR.OrangeExam,
    COLOR.green,
    COLOR.radish100,
    COLOR.blueish100,
    COLOR.blueishdeep,
    COLOR.pink100,
    COLOR.sky100,
    COLOR.indigo100,
    COLOR.lightseagreen100,
    COLOR.yellow,
    COLOR.blue,
    COLOR.red,
    COLOR.redishpink,
    COLOR.greentrue,
    COLOR.tabActive,
    COLOR.bluelight,
    COLOR.WheelEditColor1,
  ];
  

  export const STATIONS = [
    {
        label: "LEE",
        enabled: true,
        custom: false,
        id : "89323dd2-3eca-4a14-b09e-57908ee85a09"
    },
    {
        label: "ESCRIBE",
        enabled: true,
        custom: false,
        id: "f13c5796-355d-41c0-a407-f52522aec9cd"
    },
    {
        label: "ESCUCHA",
        enabled: true,
        custom: false,
        id: "7b9111aa-3450-4083-8d91-c1d412ddb324"
    },
    {
        label: "DEBATE",
        enabled : true,
        custom: false,
        id : "f0837a3f-516f-49a5-a0d1-cc915dbb1482"
    },
    {
        label: "INVESTIGA",
        enabled: true,
        custom: false,
        id : "0847ba67-ccca-4804-a33b-87500d1361b3"
    }
]

export const bingoImageUrl = "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/ea0a61f1-7aa0-4a33-cd53-f2facbeab100/public";

export const clickSoundBingo = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/audio%2Ftunetank.com_click-select.wav?alt=media&token=76dc7fae-6e68-47a7-b591-5f07042f0dfb";

export const winSoundBingo = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/audio%2Ftunetank.com_audience-applauding-cheering-and-whistling.wav?alt=media&token=a0533e07-e9fd-49a3-b2df-5a501454f684";

export const loseSoundBingo = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/audio%2Ftunetank.com_loading-robot-processing.wav?alt=media&token=6ef354f4-bbff-451b-9f01-6cc92fdee585";


export const teacherBingoTheme = "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/audio%2FMusic%20fro%20loteria.mp3?alt=media&token=74384aa5-dd3b-4ed3-8da3-3612f2d70469";
export const NewbingoImageUrl = "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/1f4b183f-1fa8-484f-c5c6-602000ef3900/public";

export const selectLoteriaImg = "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/2a8e29f8-81f2-4af9-c22f-00d969c6aa00/public";
export const InteractionCategoryType = [
    {
        label: 'none',
        value: 'none',
    },
    {
        label: 'Escucha el texto',
        value: 'eltexto',
        color:"#341B6D"
    },
    {
        label: 'Escucha el audio',
        value: 'elaudio',
        color: "#8300E6"
    }, 
    {
        label: 'Escucha la canción',
        value: 'elcancion',
        color: "#204A87"
    } 
];

export const interactionType = {
    "eltexto": "Escucha el texto",
    "elaudio": "Escucha el audio",
    "elcancion": "Escucha el cancion",
  };


  export const VIDEOS_DATA = [{
    "id": 69,
    "poster": "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/e496fa9b-82cf-4e2e-0680-16697407e300/public",
    "cover":  "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/b54abb42-d732-43ee-bf86-daa5cb136c00/public",
    "video": "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/videos%2F2024-02-12-073c2fd1-94ae-4c7d-950b-bbd512583f17AP%20SPANISH%20LAN%20-%20EL%20CORREO%20ELECTRONICO%20(2).mp4?alt=media&token=950ae8ec-59a3-4f80-91d1-77c994153338",
    "title": "EMAIL RESPONSE 2025 LESSON",
    "category": "ANÉCDOTAS SERIES",
    "tags": "",
    "for_student": false
  },
    {
      "id": 70,
      "poster": "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/4a218a3f-725b-4949-82d6-57344ababf00/public",
      "cover":"https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/a3845cac-95ad-4a84-5f9a-24221ec60200/public",
      "video": "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/videos%2F2024-02-12-98f02f62-1f8c-418a-93da-0a4b20d324cdLA%20COMPARACION%20CULTURAL%20-%202024.mp4?alt=media&token=a77669ea-a0c8-4eaf-a061-ee36e699bb9e",
      "title": "CULTURAL COMPARISON 2025 LESSON",
      "category": "ANÉCDOTAS SERIES",
      "tags": "",
      "for_student": false
    },
    {
      "id": 72,
      "poster": "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/1d242ac4-5290-4a01-498d-14ff41595400/public",
      "cover":"https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/6da106e3-75b6-466c-d3b1-f2cd9b1a5300/public",
      "video": "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/videos%2F2024-02-12-0ed4e8d0-cbdf-4d54-9329-c6a2b8dd4883AP%20VIDEOS%20-%20LA%20CONVERSACION%20SIMULADA%20(2).mp4?alt=media&token=57570a0f-cf8f-4b38-bb20-8e4f55a6a1ee",
      "title": "SIMULATED CONVERSATION 2025 LESSON",
      "category": "ANÉCDOTAS SERIES",
      "tags": "",
      "for_student": false
    },
    {
      "id": 78,
      "poster": "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/0101bfa3-5a24-42b4-03b2-28870dbf8400/public",
      "cover":"https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/d938c2ed-7a29-4798-ea2a-0bc74698b000/public",
      "video": "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/videos%2F2024-02-12-cd432a84-8cd2-40a4-ba18-7d6dc37c507aEL%20ENSAYO%20ARGUMENTATIVO%20(1).mp4?alt=media&token=f9dedd25-0487-4ad2-bcc2-11aa73c21218",
      "title": "ARGUMENTATIVE ESSAY 2025 LESSON",
      "category": "ANÉCDOTAS SERIES",
      "tags": "",
      "for_student": false
    },
  ]
  export const AP_SECTION_TITLE = {
    70:"LA COMPARACIÓN CULTURAL",
    69:"EL CORREO ELECTRÓNICO",
    71:"",
    72:"LA CONVERSACIÓN SIMULADA",
    73:"LOS ARTÍCULOS INFORMATIVOS",
    75:"AUDIOS Y PREGUNTAS",
    78:"EL ENSAYO ARGUMENTATIVO",
  }
 export  const BOOKORDER =[
    {
      "color": "rgb(27,45,79)",
      "order": [
        "32",
        "37",
        "55",
        "264",
        "282",
        "286",
        "317"
      ],
      "title": "Anécdotas Inicial 1"
    },
    {
      "color": "rgb(53,90,92)",
      "order": [
        "126",
        "140",
        "151",
        "265",
        "256",
        "286",
        "317"
      ],
      "title": "Anécdotas Inicial 2 "
    },
    {
      "color": "rgb(62,41,119)",
      "order": [
        "127",
        "143",
        "152",
        "266",
        "257",
        "286",
        "317"
      ],
      "title": "Anécdotas Inicial 3"
    },
    {
      "color": "rgb(85,151,156)",
      "order": [
        "7",
        "11",
        "53",
        "13",
        "9",
        "286",
        "317"
      ],
      "title": "Anécdotas 1"
    },
    {
      "color": "rgb(62,41,119)",
      "order": [
        "8",
        "12",
        "54",
        "14",
        "10",
        "286",
        "317"
      ],
      "title": "Anécdotas 2"
    },
    {
      "color": "rgb(237,187,80)",
      "order": [
        "141",
        "153",
        "234",
        "1",
        "258",
        "317"
      ],
      "title": "America Ed. 4 - AP Span Lang"
    },
    {
      "color": "rgb(53,90,92)",
      "order": [
        "267",
        "268",
        "269",
        "283"
      ],
      "title": "Antorcha Ed.1"
    },
    {
      "color": "rgb(53,90,92)",
      "order": [
        "311",
        "288",
        "308",
        "286"
      ],
      "title": "Las ventanas del mundo 1"
    },
    {
      "color": "rgb(53,90,92)",
      "order": [
        "312",
        "291",
        "309",
        "286"
      ],
      "title": "Las ventanas del mundo 2"
    },
    {
      "color": "rgb(53,90,92)",
      "order": [
        "313",
        "294",
        "310",
        "286"
      ],
      "title": "Las ventanas del mundo 3"
    },
    {
      "color": "rgb(53,90,92)",
      "order": [
        "296",
        "297",
        "298",
        "286"
      ],
      "title": "Las ventanas del mundo 4"
    },
    {
      "color": "rgb(53,90,92)",
      "order": [
        "300",
        "302",
        "303",
        "301",
        "281"
      ],
      "title": "Non Native Books Testing"
    }
  ]
export const question_type_generate_more = [
  { label: "Written Response", value: "Open_Ended" },
  { label: "Multiple Choice", value: "Multi_Choice" },
  { label: "True/False", value: "True_False" },
];
export const question_type_generate_more_worksheet = [
    { label: "Translate Text", value: "Translate_Text" },
    { label: "Fill in the Blanks", value: "Fill_IN_THE_Blank" },
    { label: "Select the Correct Response", value: "Select_Correct_Response" },
    { label: "Select What You Hear", value: "Select_What_You_Hear" },
  ];

  export const spanish_verb_forms_for_worksheet_tense = [
    {
      title: "Present",  
      label: "Present",
      explanation: "The present tense is used to describe actions that happen regularly or actions that are general truths.",
      example: ["Yo como una manzana.", "I eat an apple."]
    },
    {
        title: "Present Progressive (Presente Progresivo)",
        label: "Present Progressive (Presente Progresivo)",
        explanation: "The present progressive is used to describe actions that are happening right now, at the moment of speaking.",
        example: ["Yo estoy comiendo una manzana.", "I am eating an apple."]
      },
    {
      title: "Preterite",  
      label: "Preterite",
      explanation: "The preterite is used to describe completed actions in the past.",
      example: ["Yo estudié para el examen.", "I studied for the exam."]
    },
    {
      title: "Imperfect",
      label: "Imperfect",
      explanation: "The imperfect is used to describe ongoing or habitual actions in the past, or to set the scene.",
      example: ["Yo jugaba con mis amigos.", "I used to play with my friends."]
    },
    {
      title: "Present perfect",
      label: "Present Perfect",
      explanation: "The present perfect is used to describe actions that have occurred at some point in the past and are relevant to the present.",
      example: ["Yo he ayudado a mi vecino.", "I have helped my neighbor."]
    },
    {
      title: "Past continuous",
      label: "Past Continuous",
      explanation: "The past continuous is used to describe actions that were happening at a specific moment in the past or actions that were ongoing in the past.",
      example: ["Yo estaba ayudando a mi vecino.", "I was helping my neighbor."]
    },
    {
      title: "Future",
      label: "Future",
      explanation: "The future tense is used to describe actions that will happen in the future.",
      example: ["Yo ayudaré a mi vecino.", "I will help my neighbor."]
    },
    {
      title: "Future perfect",
      label: "Future Perfect",
      explanation: "The future perfect is used to describe actions that will have been completed by a certain point in the future.",
      example: ["Yo habré ayudado a mi vecino.", "I will have helped my neighbor."]
    },
    {
      title: "Conditional",
      label: "Conditional",
      explanation: "The conditional tense is used to describe actions that would happen under certain conditions or to express polite requests.",
      example: ["Yo ayudaría a mi vecino.", "I would help my neighbor."]
    },
    {
      title: "Pluperfect",
      label: "Pluperfect (Pluscuamperfecto)",
      explanation: "The pluperfect is used to describe an action that had been completed before another action in the past.",
      example: ["Yo había ayudado a mi vecino.", "I had helped my neighbor."]
    },
    {
      title: "The Perfect conditional",
      label: "Perfect Conditional (Condicional Perfecto)",
      explanation: "The perfect conditional is used to describe actions that would have happened under certain conditions in the past, but did not actually occur. It is often used to express hypothetical situations or regrets.",
      example: ["Yo habría ayudado a mi vecino.", "I would have helped my neighbor."]
    },
    {
      title: "Present subjunctive",
      label: "Present Subjunctive",
      explanation: "The present subjunctive is used to express desires, doubts, wishes, recommendations, emotions, or hypothetical situations in the present or future. It often follows certain verbs and conjunctions that trigger its use.",
      example: ["Es posible que yo ayude a mi vecino.", "It is possible that I help my neighbor."]
    },
    {
      title: "Imperfect subjunctive",
      label: "Imperfect Subjunctive (Subjuntivo Imperfecto)",
      explanation: "The imperfect subjunctive is used to express past desires, doubts, hypotheticals, or emotions, especially in uncertain situations or when events depend on other actions, often with a past tense main clause.",
      example: ["Si yo ayudara a mi vecino, él estaría feliz.", "If I helped my neighbor, he would be happy."]
    },
    {
      title: "Present perfect subjunctive",
      label: "Present Perfect Subjunctive (Subjuntivo Perfecto)",
      explanation: "The present perfect subjunctive is used to express actions that have happened in the past but are connected to the present, often under conditions of uncertainty, doubt, emotion, or necessity.",
      example: ["Es posible que yo haya ayudado a mi vecino.", "It is possible that I have helped my neighbor."]
    },
    {
      title: "Pluperfect subjunctive",
      label: "Pluperfect Subjunctive (Subjuntivo Pluscuamperfecto)",
      explanation: "The pluperfect subjunctive is used to express actions that had occurred before another action in the past, often with doubt, uncertainty, or emotion. It is typically used in hypothetical or conditional situations.",
      example: ["Si yo hubiera ayudado a mi vecino, él estaría feliz.", "If I had helped my neighbor, he would be happy."]
    }
  ];
  

export const getRandomImage = () => {
    const imageList = [
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/ac35690e-6fc5-408a-597b-6682299b5100/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/9f0b5b62-4ec5-4d42-8e42-f816d3ea1300/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/f59a298e-613e-44e7-8cc8-6b7606f90d00/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/0f0786ba-c18e-41de-a401-46cae1a5fc00/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/4dd04445-0627-4bbd-849e-bc48ddeaa000/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/bddc42c7-465f-4c9f-2bd1-a3004939e400/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/794bf936-ab36-4b77-4fd7-31d1ce157200/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/8d8dc2e5-6d7e-4e13-bca3-efcf2c99fe00/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/944e42d1-7650-49ba-0b1c-076ee0e86e00/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/ee970f4c-cf05-4998-8561-f7fab87eb700/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/8f9a73ac-36bf-496f-d8da-49b34ebdcc00/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/d3d37c1d-605d-4174-4d97-5d7ac0266b00/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/502a0efa-bcd1-452d-db9b-29b2b55dd200/public",
        "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/60856081-5eb7-41d5-70a0-c39c0cca9d00/public",
    ];

    // Randomly select an image from the list
    const randomImage = imageList[Math.floor(Math.random() * imageList.length)];

    return randomImage;
};

export const AllDataIdOneGame = "01a527d9-632c-48d9-bdb8-7f0eb41f7988";
export const AllDataIdOneGameAdmin = "bab2df80-8402-4cae-b5f7-d3fa89aae5f5";

export const worksheetUserId = ['eb844fca-2ad9-47c3-8fb8-441ccaed2a50', 'e782be4e-d6c1-495e-b9bb-db97439c7599', '0bbdda77-c17b-4d5c-92aa-d13c82978825']

export const checkWorksheetUser = (userId) => {
    return worksheetUserId?.includes(userId);
}



const soccerAnimations = [
  {
    imageUrl: PlayerRonaldoPng,
    inAnimation: "animate__fadeInBottomRight animate__slow",
    outAnimation: "animate__fadeOutLeft animate__slow",
    inSound: WowAnimation,
  },
  {
    imageUrl: SoccerBalWithFirePng,
    inAnimation: "animate__fadeInTopRight animate__slow",
    outAnimation: "animate__fadeOutTopLeft animate__slow",
    inSound: VideoGameDeath,
  },
  {
    imageUrl: PlayerMessiPng,
    inAnimation: "animate__zoomIn animate__slow",
    outAnimation: "animate__zoomOut animate__slow",
    inSound: SinisterLaugh,
  },
  {
    imageUrl: SoccreHurtPng,
    inAnimation: "animate__zoomInDown animate__slow",
    outAnimation: "animate__zoomOutDown animate__slow",
    inSound: PunchSound,
  },
  {
    imageUrl: PlayerMessiRunningPng,
    inAnimation: "animate__bounceInRight animate__slow",
    outAnimation: "animate__bounceOutLeft animate__slow",
    inSound: NextLevelSound,
  },
  {
    imageUrl: SoccerKickingBallPng,
    inAnimation: "animate__fadeInBottomLeft animate__slow",
    outAnimation: "animate__fadeOutRightBig animate__slow",
    inSound: multiPopSound,
  },
  {
    imageUrl: FingerGloveGamePng,
    inAnimation: "animate__tada animate__slow",
    outAnimation: "animate__fadeOutLeft animate__slow",
    inSound: HappyPopSound,
  },
  {
    imageUrl: PlayerCelebratingPng,
    inAnimation: "animate__zoomInDown animate__slow",
    outAnimation: "animate__zoomOutRight animate__slow",
    inSound: gameSplash,
  },
  {
    imageUrl: MulticolorSoccerBallPng,
    inAnimation: "animate__rollIn animate__slow",
    outAnimation: "animate__rollOut animate__slow",
    inSound: SinisterLaugh,
  },
  {
    imageUrl: PlayerRunningWithBallPng,
    inAnimation: "animate__fadeInTopRight animate__slow",
    outAnimation: "animate__fadeOutTopLeft animate__slow",
    inSound: WowAnimation,
  },
  {
    imageUrl: BobbleHeadFigure2Png,
    inAnimation: "animate__bounceIn animate__slow",
    outAnimation: "animate__backOutUp animate__slow",
    inSound: multiPopSound,
  },
  {
    imageUrl: BobbleHeadFigurePng,
    inAnimation: "animate__backInUp animate__slow",
    outAnimation: "animate__backOutRight animate__slow",
    inSound: gameSplash,
  },
  {
    imageUrl: PlayerKickcingBallBackwardsPng,
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__rotateOutUpLeft animate__slow",
    inSound: VideoGameDeath,
  },
  {
    imageUrl: PlayerStandingWithBallPng,
    inAnimation: "animate__lightSpeedInRight animate__slow",
    outAnimation: "animate__lightSpeedOutLeft animate__slow",
    inSound: PunchSound,
  },
  {
    imageUrl: PlayerWalkingAwayPng,
    inAnimation: "animate__slideInUp animate__slow",
    outAnimation: "animate__slideOutUp animate__slow",
    inSound: multiPopSound,
  },
  {
    imageUrl: PlayerWithBallPng,
    inAnimation: "animate__flipInY animate__slow",
    outAnimation: "animate__flip animate__slow",
    inSound: SinisterLaugh,
  },
  {
    imageUrl: SassyPlayerWalkingAwayPng,
    inAnimation: "animate__flash animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: HappyPopSound,
  },
  {
    imageUrl: GolieStoppingBallPng,
    inAnimation: "animate__fadeInBottomRight animate__slow",
    outAnimation: "animate__fadeOutTopLeft animate__slow",
    inSound: gameSplash,
  },
  {
    imageUrl: FootballWithFirePng,
    inAnimation: "animate__fadeInTopRight animate__slow",
    outAnimation: "animate__fadeOutTopLeft animate__slow",
    inSound: WowAnimation,
  },
  {
    imageUrl: GirlWithFootballPng,
    inAnimation: "animate__fadeInBottomRight animate__slow",
    outAnimation: "animate__fadeOutLeft animate__slow",
    inSound: PunchSound,
  },
  {
    imageUrl: PlayerJumpWithBallPng,
    inAnimation: "animate__zoomIn animate__slow",
    outAnimation: "animate__zoomOut animate__slow",
    inSound: multiPopSound,
  },
  {
    imageUrl: PlayerShoesPng,
    inAnimation: "animate__zoomInDown animate__slow",
    outAnimation: "animate__zoomOutDown animate__slow",
    inSound: PunchSound,
  },
  {
    imageUrl: PlayerRunWithFootballPng,
    inAnimation: "animate__bounceInRight animate__slow",
    outAnimation: "animate__bounceOutLeft animate__slow",
    inSound: SinisterLaugh,
  },
  {
    imageUrl: PlayerGoalFootballPng,
    inAnimation: "animate__fadeInTopRight animate__slow",
    outAnimation: "animate__fadeOutTopLeft animate__slow",
    inSound: HappyPopSound,
  },
  {
    imageUrl: RunThunderPng,
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: PunchSound,
  },

  //228
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/52bbf037-d59f-4b9c-ebdf-b0eaccb4be00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars3,
  },

  //230
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/62a02fcf-4ecb-4b98-58e3-1abc7ab7f900/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars1,
  },

  //234
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/5e5b425c-c4c9-4b9e-4449-e36ff5da2200/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars2,
  },

  //236
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/d7b359eb-cc15-4aad-f35f-a8eea76a4d00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars3,
  },

  //229
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/e0f2bc4b-4f12-4e3d-58a7-099e2c195500/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars1,
  },

  // 231
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/991733fc-c8f8-443d-58a6-ad6b8e39a300/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars2,
  },

  // 232
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/afcb4f34-6cba-47ea-edb0-36b5f063f000/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars3,
  },

  // 233
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/f4b96845-217b-4eb8-6fb3-f59507f43200/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars1,
  },

  // 235
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/d7e37868-6663-47e1-415e-14f79c7ec600/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars2,
  },

  // 237
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/63c9091d-2152-4e38-b621-ad161a90ec00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: cars3,
  },

  //199
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/d4546d81-c197-4573-3b09-08af99080500/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: wman1,
  },
  //200
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/98e52d51-fade-4d13-5482-f6bee355b700/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: wman2,
  },
  //201
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/558a7c05-d99d-421c-8a48-635e72d89c00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: wman3,
  },
  //202
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/788df99b-e23d-466b-9242-67168f6a9d00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: wman4,
  },
  //203
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/46df11f2-deaf-43d2-37e1-d6affda88500/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: wman5,
  },
  //204
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/71dcab08-e2f5-4d5a-d1f0-67284b693d00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: wman6,
  },
  //205
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/6945994f-4116-49a6-7ebb-48cf74376300/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: wman1,
  },
  //206
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/47a1ba97-90df-4afd-d204-f4ff206c9900/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: wman2,
  },
  //207
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/44cb92b1-ecd4-49b5-a0f3-bb26a43b0600/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: wman3,
  },
  //208
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/44cb92b1-ecd4-49b5-a0f3-bb26a43b0600/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster1,
  },
  //209
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/aed6a606-7192-47f0-aebd-9549a5f16200/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster2,
  },
  //210
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/7c3ac81f-7bb9-46be-ac2c-ec5a57e12900/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster3,
  },
  //211
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/dac359da-f55e-4074-f395-65457c4b1600/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster4,
  },
  //212
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/8a764c56-d951-4127-1936-758efefc6000/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster5,
  },
  //213
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/26cffaeb-e28a-4525-d2e2-dc5e1855dc00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster1,
  },
  //214
  {
    imageUrl:
    "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/e936e5fb-7602-43c1-c268-b0a79231e800/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster2,
  },
  //215
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/a78deb79-178c-4354-6498-cbbbf30d5d00/thumbnail",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster3,
  },
  //216
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/99cd4a80-2808-4ee9-1a48-71e3ff977b00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster4,
  },
  //217
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/5229ed58-366f-42ea-3aab-899d49ebef00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster5,
  },
  //218
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/b569ef7f-ff08-43db-06e4-ef758baea900/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster1,
  },
  //219
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/c1f859b4-283f-4ada-148a-724ac081de00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster2,
  },
  //220
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/eef75691-17a1-4f1e-c5f5-201dadecba00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster3,
  },
  //221
  {
    imageUrl:
      "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/0747655d-1b6e-4009-6459-8b91c9c12c00/public",
    inAnimation: "animate__jackInTheBox animate__slow",
    outAnimation: "animate__fadeOut animate__slow",
    inSound: monster4,
  },
];


  export const getModernImage = () => {
      return soccerAnimations;
  };

  export const convertToHtml = (lessonData) => {
    const lines = lessonData?.split("\n");
    let html = '<div class="lesson-plan">';
  
    lines.forEach((line) => {
      if (line.startsWith("###")) {
        html += `<h3>${line.substring(4)}</h3>`;
      } else if (line.startsWith("**")) {
        const boldParts = line.split("**").filter(Boolean);
        html += `<strong>${boldParts.join("</strong><strong>")}</strong>`;
      } else if (line.startsWith("- ")) {
        html += `<li>${line.substring(2)}</li>`;
      } else if (line.startsWith("  - ")) {
        html += `<ul><li>${line.substring(4)}</li></ul>`;
      } else if (line.startsWith("    - ")) {
        html += `<ul><ul><li>${line.substring(6)}</li></ul></ul>`;
      } else {
        html += `<p>${line}</p>`;
      }
    });
  
    html += "</div>";
    return html;
  };

  export const photoCollageData = [
    {
      id: 1,
      className: "collage-row-1-col-1",
      height: "200px",
      width: "150px",
      position: { top: "3.837%", left: "2.836981%" },
      rotate: "1deg",
      image: "",
    },
    {
      id: 2,
      className: "collage-row-1-col-2",
      height: "200px",
      width: "150px",
      position: { top: "20.247981122257222%", left: "15.247981122257224%" },
      rotate: "2deg",
      image: "",
    },
    {
      id: 3,
      className: "collage-row-1-col-3 ",
      height: "200px",
      width: "150px",
      position: { top: "22.029423024404554%", left: "42.02942302440455%" },
      rotate: "4deg",
      image: "",
    },
    {
      id: 4,
      className: "collage-row-1-col-4",
      height: "200px",
      width: "150px",
      position: { top: "17.86299468333202%", left: "62.86299468333202%" },
      rotate: "4deg",
      image: "",
    },
    {
      id: 5,
      className: "collage-row-2-col-1",
      height: "200px",
      width: "150px",
      position: { top: "50.29730223736152%", left: "0.2973022373615213%" },
      rotate: "-3deg",
      image: "",
    },
    {
      id: 6,
      className: "collage-row-2-col-2",
      height: "200px",
      width: "150px",
      position: { top: "52.10760721499966%", left: "17.10760721499966%" },
      rotate: "4deg",
      image: "",
    },
    {
      id: 7,
      className: "collage-row-2-col-3",
      height: "200px",
      width: "150px",
      position: { top: "50.98557037657025%", left: "40.98557037657025%" },
      rotate: "-3deg",
      image: "",
    },
    {
      id: 8,
      className: "collage-row-2-col-4",
      height: "200px",
      width: "150px",
      position: { top: "49.06324961926798%", left: "64.06324961926798%" },
      rotate: "4deg",
      image: "",
    },
    {
      id: 9,
      className: "collage-row-3-col-1",
      height: "200px",
      width: "150px",
      position: { top: "80.97744706417711%", left: "0.9774470641771114%" },
      rotate: "0deg",
      image: "",
    },
    {
      id: 10,
      className: "collage-row-3-col-2",
      height: "200px",
      width: "150px",
      position: { top: "79.66206511385137%", left: "14.662065113851371%" },
      rotate: "1deg",
      image: "",
    },
    {
      id: 11,
      className: "collage-row-3-col-3",
      height: "200px",
      width: "150px",
      position: { top: "81.36343599559063%", left: "41.363435995590635%" },
      rotate: "2deg",
      image: "",
    },
    {
      id: 12,
      className: "collage-row-3-col-4",
      height: "200px",
      width: "150px",
      position: { top: "77.90615761120307%", left: "62.90615761120307%" },
      rotate: "-1deg",
      image: "",
    },
    {
        id: 13,
        className: "collage-row-3-col-4",
        height: "200px",
        width: "150px",
        position: { top: "77.90615761120307%", left: "62.90615761120307%" },
        rotate: "-1deg",
        image: "",
    },
      
    {
        id: 14,
        className: "collage-row-3-col-4",
        height: "200px",
        width: "150px",
        position: { top: "77.90615761120307%", left: "62.90615761120307%" },
        rotate: "-1deg",
        image: "",
      },
      
    {
        id: 15,
        className: "collage-row-3-col-4",
        height: "200px",
        width: "150px",
        position: { top: "77.90615761120307%", left: "62.90615761120307%" },
        rotate: "-1deg",
        image: "",
      },
      
    {
        id: 16,
        className: "collage-row-3-col-4",
        height: "200px",
        width: "150px",
        position: { top: "77.90615761120307%", left: "62.90615761120307%" },
        rotate: "-1deg",
        image: "",
      },
      
    {
        id: 17,
        className: "collage-row-3-col-4",
        height: "200px",
        width: "150px",
        position: { top: "77.90615761120307%", left: "62.90615761120307%" },
        rotate: "-1deg",
        image: "",
      },
      
    {
        id: 18,
        className: "collage-row-3-col-4",
        height: "200px",
        width: "150px",
        position: { top: "77.90615761120307%", left: "62.90615761120307%" },
        rotate: "-1deg",
        image: "",
      },
      
    {
        id: 19,
        className: "collage-row-3-col-4",
        height: "200px",
        width: "150px",
        position: { top: "77.90615761120307%", left: "62.90615761120307%" },
        rotate: "-1deg",
        image: "",
      },
      
    {
        id: 20,
        className: "collage-row-3-col-4",
        height: "200px",
        width: "150px",
        position: { top: "77.90615761120307%", left: "62.90615761120307%" },
        rotate: "-1deg",
        image: "",
      },
  ];

   export  const dropDownMenu = [
      {
        value: 1,
      },
      {
        value: 2,
      },
      {
        value: 3,
      },
      {
        value: 4,
      },
      {
        value: 6,
      },
      {
        value: 8,
      },
      {
        value: 10,
      },
      {
        value: 12,
      },
      {
        value: 14,
      },
      {
        value: 16,
      },
      {
        value: 18,
      },
      {
        value: 20,
      },
    ];

  export const imageUpload = [
    {
      value: 1,
    },
    {
      value: 2,
    },
    {
      value: 3,
    },
    {
      value: 4,
    },
    {
      value: 5,
    },
    {
      value: 6,
    },
  ]
  export const detectTextLanguage = (text) => {
    // Early return if no text
    if (!text?.trim()) return "en-US";
    // Common character patterns for different languages
    const patterns = {
      spanish: {
        pattern:
          /[áéíóúñ¿¡]|(\b(el|la|los|las|de|en|es|está|están|como|qué|por|para|con|su|ese|esta|más)\b)/gi,
        code: "es-ES"
      },
      english: {
        pattern:
          /\b(the|is|are|was|were|be|been|has|have|had|do|does|did|will|would|can|could|should|may|might|must|am|an|a|in|on|at|by|to|of)\b/gi,
        code: "en-US"
      },
      french: {
        pattern:
          /[éèêëàâçîïôûùüÿœæ]|(\b(le|la|les|un|une|des|est|sont|être|avoir|fait|dans|sur|pour|avec|ce|cette)\b)/gi,
        code: "fr-FR"
      },
      german: {
        pattern:
          /[äöüß]|(\b(der|die|das|ein|eine|ist|sind|und|ich|sie|mir|mich|du|für|mit|bei|seit|von|aus)\b)/gi,
        code: "de-DE"
      }
    };

    // Count matches for each language
    const matches = Object.entries(patterns).map(([language, { pattern, code }]) => {
      const matchCount = (text.match(pattern) || []).length;
      return { language, code, matchCount };
    });

    // Sort by match count in descending order
    matches.sort((a, b) => b.matchCount - a.matchCount);

    // If we have matches, return the language code with the most matches
    if (matches[0].matchCount > 0) {
      return matches[0].code;
    }

    // Default to English if no clear matches
    return "en-US";
  };
  export function transformToGrid(array, rowSize = 4) {
    try{
         // Check if the array is valid
    if (!Array.isArray(array) || array.length === 0) {
        return array;
      }
      
      // Check if array is already in grid format ([Array(4), Array(4), Array(4), Array(4)])
      const isAlreadyGrid = array.every(item => Array.isArray(item));
      if (isAlreadyGrid) {
        return array; // Already in grid format, return as is
      }
      
      // Process the array into a grid
      const grid = [];
      for (let i = 0; i < array.length; i += rowSize) {
        grid.push(array.slice(i, i + rowSize));
      }
      
      return grid;
    }catch(e){
      Sentry.captureException(`642 Error in transformToGrid: ${e}`);
        console.log(e);
        return array;
    }
   
  }

  export const GradeLevel = [
    {
      value: "6th",
    },
    {
      value: "7th",

    },
    {
      value: "8th",

    },
    {
      value: "9th",

    },
    {
      value: "10th",
 
    },
    {
      value: "11th",
 
    },
    {
      value: "12th"
    }
  ];

  export const dropdownForResourceType = [
    {
      label: "1Way Resource",
      value: resource_types.resource,
    },
    {
      label: "1Way Story",
      value: resource_types.story,
    },
    {
      label: "Balcón cultural",
      value: resource_types.balcon,
    },
    {
      label: "Conectándome",
      value: resource_types.conectándome,
    },
    {
      label: "Comunidad",
      value: resource_types.comunidad,
    },
    {
      label: "Informate",
      value: resource_types.informate,
    },
    {
      label: "AP",
      value: resource_types.AP,
    },
  ];

export const BINGO_THEME_SONG = [{
  url: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/loteria%2Faudio%2F1%20-%20La%20montana%20de%20la%20salsa.mp3?alt=media&token=8b253cdd-5e08-4a6a-b430-e6cd06389f4c",
  title: "La montaña de la salsa"
}, {
  url: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/loteria%2Faudio%2F2-%20Una%20cancion%20moderna.mp3?alt=media&token=0864187c-c322-4545-84cd-fe323d492046",
  title: "Una canción moderna"
}, {
  url: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/loteria%2Faudio%2F3%20-%20Lo%20mejor%20del%20lugar.mp3?alt=media&token=69995eb6-45b9-4fa9-bf5f-475523e54450",
  title: "Lo mejor del lugar"
}, {
  url: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/loteria%2Faudio%2F4%20-%20La%20vida%20cotidiana.mp3?alt=media&token=ef0e3205-deeb-4f44-ae8d-ded4d04f3de8",
  title: "La vida cotidiana"
}, {
  url: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/loteria%2Faudio%2F5%20-%20El%20medico.mp3?alt=media&token=19ec3fac-38be-4450-8289-c42a30f0b659",
  title: "El médico"
}]

export const STANDARD_GRADE_LEVEL = [
  {
    "state": "Common Core",
    "Description": "Common Core State Standards",
    "code": "COMMONCORE"
  },
  {
    "state": "California",
    "Description": "California World Languages Standards (aligned with ACTFL)",
    "code": "CAWL"
  },
  {
    "state": "Colorado",
    "Description": "Colorado Academic Standards for World Languages",
    "code": "CO-WL"
  },
  {
    "state": "Connecticut",
    "Description": "Connecticut World Language Standards",
    "code": "CT-WL"
  },
  {
    "state": "Delaware",
    "Description": "Delaware World Language Standards",
    "code": "DE-WL"
  },
  {
    "state": "Florida",
    "Description": "Florida B.E.S.T. World Languages Standards",
    "code": "FL-BEST-WL"
  },
  {
    "state": "Georgia",
    "Description": "Georgia Standards of Excellence for World Languages",
    "code": "GA-WL"
  },
  {
    "state": "Illinois",
    "Description": "Illinois Learning Standards (SLA)",
    "code": "ILS-SLA"
  },
  {
    "state": "Indiana",
    "Description": "Indiana Academic Standards for World Languages",
    "code": "IN-WL"
  },
  {
    "state": "Iowa",
    "Description": "Iowa Core World Language Standards",
    "code": "IA-WL"
  },
  {
    "state": "Massachusetts",
    "Description": "Massachusetts World Language Curriculum Framework",
    "code": "MA-WL"
  },
  {
    "state": "Michigan",
    "Description": "Michigan World Language Standards",
    "code": "MI-WL"
  },
  {
    "state": "Minnesota",
    "Description": "Minnesota Academic Standards for World Languages",
    "code": "MN-WL"
  },
  {
    "state": "New Jersey",
    "Description": "New Jersey Student Learning Standards – World Languages",
    "code": "NJSLS-WL"
  },
  {
    "state": "New Mexico",
    "Description": "New Mexico World Language Content Standards",
    "code": "NM-WL"
  },
  {
    "state": "New York",
    "Description": "New York state World Language Learning Standards (NYSSLS)",
    "code": "NYSSLS"
  },
  {
    "state": "North Carolina",
    "Description": "North Carolina Essential Standards for World Languages",
    "code": "NC-WL"
  },
  {
    "state": "Ohio",
    "Description": "Ohio Learning Standards for World Languages",
    "code": "OH-WL"
  },
  {
    "state": "Oklahoma",
    "Description": "Oklahoma Academic Standards for World Languages",
    "code": "OK-WL"
  },
  {
    "state": "Oregon",
    "Description": "Oregon World Language Standards",
    "code": "OR-WL"
  },
  {
    "state": "Rhode Island",
    "Description": "Rhode Island World Language Standards",
    "code": "RI-WL"
  },
  {
    "state": "South Dakota",
    "Description": "South Dakota World Language Standards",
    "code": "SD-WL"
  },
  {
    "state": "Tennessee",
    "Description": "Tennessee Academic Standards for World Languages",
    "code": "TN-WL"
  },
  {
    "state": "Texas",
    "Description": "Texas Essential Knowledge and Skills for Languages Other Than English (TEKS LOTE)",
    "code": "TX-TEKS-LOTE"
  },
  {
    "state": "Virginia",
    "Description": "Virginia World Language Standards of Learning (SOL)",
    "code": "VA-SOL-WL"
  },
  {
    "state": "Washington",
    "Description": "Washington World Language Learning Standards",
    "code": "WA-WL"
  },
  {
    "state": "Wisconsin",
    "Description": "Wisconsin Standards for World Languages",
    "code": "WI-WL"
  }
]